import { useState, useEffect } from 'react'
import { campaignsAPI } from '../../../services/api'

/**
 * Modal que lista campañas con status='active' y permite seleccionar varias.
 * @param {string[]} initialSelected - IDs UUID seleccionados al abrir
 * @param {Function} onConfirm - (ids: string[]) => void
 * @param {Function} onClose - () => void
 */
export default function ExcludeCampaignModal({ initialSelected, onConfirm, onClose }) {
  const [campaigns, setCampaigns] = useState([])
  const [loading, setLoading] = useState(true)
  const [selected, setSelected] = useState(initialSelected || [])
  const [error, setError] = useState(false)

  useEffect(() => {
    let mounted = true
    campaignsAPI.getCampaigns()
      .then(res => {
        if (!mounted) return
        // Backend returns { success: true, campaigns: [...] }, axios wraps in res.data
        const all = res?.data?.campaigns || res?.data || res?.campaigns || res || []
        const active = Array.isArray(all) ? all.filter(c => c.status === 'active') : []
        setCampaigns(active)
      })
      .catch(err => {
        console.error('[ExcludeCampaignModal] error:', err)
        if (mounted) setError(true)
      })
      .finally(() => { if (mounted) setLoading(false) })
    return () => { mounted = false }
  }, [])

  const toggle = (id) => {
    setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id])
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center" onClick={onClose}>
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-96 max-w-full max-h-[90vh] flex flex-col" onClick={e => e.stopPropagation()}>
        <div className="p-3 -m-6 mb-4 rounded-t-lg border-b bg-rose-50 dark:bg-rose-900/30 border-rose-300 dark:border-rose-700">
          <h3 className="text-base font-semibold text-rose-800 dark:text-rose-200">📢 Excluir campañas activas</h3>
          <p className="text-xs text-rose-700 dark:text-rose-300 mt-1">
            Los contactos ya enrolados en estas campañas no aparecerán en los resultados
          </p>
        </div>
        <div className="flex-1 overflow-y-auto -mx-2 px-2">
          {loading && <p className="text-sm text-gray-500 py-4 text-center">Cargando…</p>}
          {!loading && error && (
            <p className="text-sm text-rose-600 dark:text-rose-400 py-4 text-center">
              Error al cargar campañas
            </p>
          )}
          {!loading && !error && campaigns.length === 0 && (
            <p className="text-sm text-gray-500 py-4 text-center">No hay campañas activas.</p>
          )}
          {!loading && !error && campaigns.length > 0 && (
            <ul className="space-y-1 max-h-64">
              {campaigns.map(c => (
                <li key={c.id}>
                  <label className="flex items-center gap-2 p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={selected.includes(c.id)}
                      onChange={() => toggle(c.id)}
                      className="rounded"
                    />
                    <span className="text-sm text-gray-900 dark:text-gray-100">{c.name}</span>
                  </label>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onClose}
            type="button"
            className="px-4 py-2 text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
          >
            Cancelar
          </button>
          <button
            onClick={() => { onConfirm(selected); onClose() }}
            type="button"
            className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  )
}
